import React from 'react';
import i18next from 'i18next';
import { toast } from 'react-toastify';

import { NormalizedRestaurant } from 'types/restaurants';
import APIService from 'services/api';
import { LOG_BAG } from 'utils/log';
import { User } from 'types';
import AddUserForm from './AddUserForm';


interface ViewAddDriverProps {
  restaurant: NormalizedRestaurant;
  onSuccess: (driver: User) => void;
}

const ViewAddDriver = (props: ViewAddDriverProps) => {
  const { restaurant } = props;
  const handleAddDriver = (values) => {
    return APIService.post(`/restaurants/${restaurant.id}/drivers`, values)
      .then((newDriver: User) => {
        toast.success(i18next.t('view-add-driver.driver-added'));
        props.onSuccess(newDriver);
      })
      .catch((error: Error) => {
        toast.error(i18next.t('view-add-driver.driver-add-error'));
        LOG_BAG.logError('Driver add error', error);
      });
  };
  return <AddUserForm isDriver onAddUser={handleAddDriver} restaurantId={restaurant.id} />;
};

export default ViewAddDriver;
